document.addEventListener('DOMContentLoaded', function() {
  const slides = document.querySelectorAll('.hero-slider .slide');
  let currentSlide = 0;
  const totalSlides = slides.length;

  console.log('Total slides:', totalSlides);  // Verificar si las diapositivas se están detectando

  function showSlide(index) {
    slides.forEach((slide, i) => {
      if (i === index) {
        slide.classList.add('active');
      } else {
        slide.classList.remove('active');
      }
    });
  }

  function nextSlide() {
    currentSlide = (currentSlide + 1) % totalSlides;
    showSlide(currentSlide);
  }

  // Inicializa el slider mostrando la primera imagen
  showSlide(currentSlide);

  // Cambia de imagen cada 5 segundos
  setInterval(nextSlide, 5000);
});
